export function getErrorFromUnknown(error: unknown): Error {
  if (error instanceof Error) {
    return error;
  }

  if (error === null || error === undefined) {
    return new Error('Unknown error: An error was thrown but it was null or undefined.');
  }

  if (typeof error === 'string') {
    return new Error(error);
  }

  if (error instanceof Response) {
    return new Error(`Failed to fetch: ${error.statusText} (${error.status})`);
  }

  if (typeof error === 'object') {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const constructorName = ('constructor' in error ? Object.getPrototypeOf(error)?.constructor?.name : undefined) as
      | string
      | undefined;

    const message = 'message' in error ? (error as { message: string }).message : undefined;

    return new Error(getErrorMessage({ constructorName, message }));
  }

  return new Error('Unknown error');
}

export function getErrorMessage({
  constructorName,
  message
}: {
  constructorName: string | undefined;
  message: string | undefined;
}) {
  if (constructorName && message) {
    return `An error of type '${constructorName}' was thrown. Message: ${message}`;
  }
  if (constructorName) {
    return `An error of type '${constructorName}' was thrown.`;
  }
  if (message) {
    return message;
  }
  return 'Unknown error';
}
